import { newRidgeState } from 'react-ridge-state';
export const historyState = newRidgeState<any>(null);
